import { REACT_APP_MODE } from '../config/env';

if (REACT_APP_MODE === 'PRODUCTION_MODE') {
  // eslint-disable-next-line func-names
  console.info = function () {};
}
